module.exports = __webpack_public_path__ + "img/ergoregion-5.a2235286.png";